import React, { createContext, useContext, useState, useEffect } from "react";
import useCurrency from "../../hooks/useCurrency";
import { AuthContext } from "../Auth/AuthContext";

const CurrencyContext = createContext();

const CurrencyProvider = ({ children }) => {
  const { user } = useContext(AuthContext);
  const currencyHook = useCurrency();
  const [globalCurrency, setGlobalCurrency] = useState(null);

  useEffect(() => {
    const initializeCurrency = async () => {
      // Só busca currency se o usuário estiver autenticado
      if (!user) {
        return;
      }

      try {
        const currency = await currencyHook.getCurrency();
        setGlobalCurrency(currency);
      } catch (err) {
        console.error("Error initializing currency:", err);
      }
    };

    initializeCurrency();
  }, [user]);

  const updateCurrency = async (currencyCode) => {
    try {
      const newCurrency = await currencyHook.updateCurrency(currencyCode);
      setGlobalCurrency(newCurrency);
      return newCurrency;
    } catch (err) {
      throw err;
    }
  };

  const formatCurrency = (value) => {
    return currencyHook.formatCurrency(value, globalCurrency);
  };

  const value = {
    currency: globalCurrency,
    loading: currencyHook.loading,
    updateCurrency,
    formatCurrency,
    getAvailableCurrencies: currencyHook.getAvailableCurrencies,
  };

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
};

const useCurrencyContext = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error("useCurrencyContext must be used within a CurrencyProvider");
  }
  return context;
};

export { CurrencyContext, CurrencyProvider, useCurrencyContext };
